'use client';
import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
  XIcon,
} from 'react-share';
import { useTranslations } from 'next-intl';

export const SocialShare: React.FC = () => {
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);
  const t = useTranslations();

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);
  if (!currentUrl) return null;
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Typography>{t('Social.share')}</Typography>
      <TwitterShareButton url={currentUrl}>
        <XIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
      </TwitterShareButton>
      <LinkedinShareButton url={currentUrl}>
        <LinkedinIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
      </LinkedinShareButton>
      <FacebookShareButton url={currentUrl}>
        <FacebookIcon bgStyle={{ backgroundColor: 'primary.main' }} size={32} round />
      </FacebookShareButton>
    </Stack>
  );
};
